module.exports = __webpack_public_path__ + "img/material-symbols_floor.393af17c.svg";